import NotificationPlugin from './notification'
import ConfirmPlugin from './confirm'

export default {
  install: function(Vue, opt) {
    Vue.use(NotificationPlugin)
    Vue.use(ConfirmPlugin)
  }
}
